"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prosemirror_inputrules_1 = require("prosemirror-inputrules");

var prosemirror_state_1 = require("prosemirror-state");

var Extension_1 = __importDefault(require("../lib/Extension"));

var isInCode_1 = __importDefault(require("../queries/isInCode"));

var BlockMenuTrigger_1 = require("./BlockMenuTrigger");

var OPEN_REGEX = /(?:^|\s):([0-9a-zA-Z_+-]+)?$/;
var CLOSE_REGEX = /(?:^|\s):(([0-9a-zA-Z_+-]*\s+)|(\s+[0-9a-zA-Z_+-]+)|[^0-9a-zA-Z_+-]+)$/;

var EmojiTrigger =
/*#__PURE__*/
function (_Extension_1$default) {
  _inherits(EmojiTrigger, _Extension_1$default);

  function EmojiTrigger() {
    _classCallCheck(this, EmojiTrigger);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmojiTrigger).apply(this, arguments));
  }

  _createClass(EmojiTrigger, [{
    key: "inputRules",
    value: function inputRules() {
      var _this = this;

      return [new prosemirror_inputrules_1.InputRule(OPEN_REGEX, function (state, match) {
        if (match && state.selection.$from.parent.type.name === "paragraph" && !isInCode_1.default(state)) {
          _this.options.onOpen(match[1]);
        }

        return null;
      }), new prosemirror_inputrules_1.InputRule(CLOSE_REGEX, function (state, match) {
        if (match) {
          _this.options.onClose();
        }

        return null;
      })];
    }
  }, {
    key: "name",
    get: function get() {
      return "emojimenu";
    }
  }, {
    key: "plugins",
    get: function get() {
      var _this2 = this;

      return [new prosemirror_state_1.Plugin({
        props: {
          handleClick: function handleClick() {
            _this2.options.onClose();

            return false;
          },
          handleKeyDown: function handleKeyDown(view, event) {
            if (event.key === "Backspace") {
              setTimeout(function () {
                var pos = view.state.selection.$from.pos;
                return BlockMenuTrigger_1.run(view, pos, pos, OPEN_REGEX, function (state, match) {
                  if (match) {
                    _this2.options.onOpen(match[1]);
                  } else {
                    _this2.options.onClose();
                  }

                  return null;
                });
              });
            }

            if (event.key === "Enter" || event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Tab") {
              var pos = view.state.selection.$from.pos;
              return BlockMenuTrigger_1.run(view, pos, pos, OPEN_REGEX, function (state, match) {
                return match ? true : null;
              });
            }

            return false;
          }
        }
      })];
    }
  }]);

  return EmojiTrigger;
}(Extension_1.default);

exports.default = EmojiTrigger;